import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '@modules/analysis/api/stratifications';

const namespace = 'ANALYSIS';

export const FETCH_STRATIFICATION_RUNS = createRequestTypes(
  `${namespace}/FETCH_STRATIFICATION_RUNS`,
);

export const fetchStratificationRuns = makeApiActionCreatorV3(
  api.fetchStratificationRuns,
  FETCH_STRATIFICATION_RUNS[START],
  FETCH_STRATIFICATION_RUNS[SUCCESS],
  FETCH_STRATIFICATION_RUNS[ERROR],
);

export const CREATE_STRATIFICATION_RUN = createRequestTypes(
  `${namespace}/CREATE_STRATIFICATION_RUN`,
);

export const createStratificationRun = makeApiActionCreatorV3(
  api.createStratificationRun,
  CREATE_STRATIFICATION_RUN[START],
  CREATE_STRATIFICATION_RUN[SUCCESS],
  CREATE_STRATIFICATION_RUN[ERROR],
);

export const FETCH_STRATIFICATION_RUN_DETAIL = createRequestTypes(
  `${namespace}/FETCH_STRATIFICATION_RUN_DETAIL`,
);

export const fetchStratificationRunDetail = makeApiActionCreatorV3(
  api.fetchStratificationRunDetail,
  FETCH_STRATIFICATION_RUN_DETAIL[START],
  FETCH_STRATIFICATION_RUN_DETAIL[SUCCESS],
  FETCH_STRATIFICATION_RUN_DETAIL[ERROR],
);

export const FETCH_STRATIFICATION_RUN_TAXING_UNIT_SUMMARY = createRequestTypes(
  `${namespace}/FETCH_STRATIFICATION_RUN_TAXING_UNIT_SUMMARY`,
);

export const fetchStratificationRunTaxingUnitSummary = makeApiActionCreatorV3(
  api.fetchStratificationRunTaxingUnitSummary,
  FETCH_STRATIFICATION_RUN_TAXING_UNIT_SUMMARY[START],
  FETCH_STRATIFICATION_RUN_TAXING_UNIT_SUMMARY[SUCCESS],
  FETCH_STRATIFICATION_RUN_TAXING_UNIT_SUMMARY[ERROR],
);

export const FETCH_STRATIFICATION_RUN_TAXING_UNITS = createRequestTypes(
  `${namespace}/FETCH_STRATIFICATION_RUN_TAXING_UNITS`,
);

export const fetchStratificationRunTaxingUnits = makeApiActionCreatorV3(
  api.fetchStratificationRunTaxingUnits,
  FETCH_STRATIFICATION_RUN_TAXING_UNITS[START],
  FETCH_STRATIFICATION_RUN_TAXING_UNITS[SUCCESS],
  FETCH_STRATIFICATION_RUN_TAXING_UNITS[ERROR],
);

export const DELETE_STRATIFICATION_RUN = createRequestTypes(
  `${namespace}/DELETE_STRATIFICATION_RUN`,
);

export const deleteStratificationRun = makeApiActionCreatorV3(
  api.deleteStratificationRun,
  DELETE_STRATIFICATION_RUN[START],
  DELETE_STRATIFICATION_RUN[SUCCESS],
  DELETE_STRATIFICATION_RUN[ERROR],
);

export const UPDATE_STRATIFICATION_RUN = createRequestTypes(
  `${namespace}/UPDATE_STRATIFICATION_RUN`,
);

export const updateStratificationRun = makeApiActionCreatorV3(
  api.updateStratificationRun,
  UPDATE_STRATIFICATION_RUN[START],
  UPDATE_STRATIFICATION_RUN[SUCCESS],
  UPDATE_STRATIFICATION_RUN[ERROR],
);

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});